import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { makeAPI, makeApiCall_v1 } from "../../services/api";
import { showInfo, showSuccess } from "../../utils/utils";

export default function GameJamRegister() {
  const [form, setForm] = React.useState({
    name: "",
    college: "",
    college_id: null,
    email: "",
    contact: "",
    age: "",
    gameTitle: "",
    gameDescription: "",
    controlDescription: "",
    gameThumbnail: null,
    gameFile: null,
    media: "landscape",
    sub_id: ""
  });
  const [user, setUser] = useState('');
  const [errors, setErrors] = React.useState({});
  const [success, setSuccess] = React.useState("");
  const [sandbox, setSandbox] = React.useState("");
  const hasDraftRef = React.useRef(false);
  const maxSize = 1024 * 1024; // 1mb
  const maxZipSize = 100 * 1024 * 1024; // 100mb
  const [FormKey, setFormKey] = React.useState(false); //false - not register , true = register.
  const location = useLocation();
  const sub_id = location.state?.sub_id;
  const event_id = location.state?.event_id;
  const isregister_stat = location.state?.isregister;
  const [isregister, setisregister] = useState(isregister_stat);
  const storedUser = JSON.parse(localStorage.getItem("user"));
  // console.log("LOCATION STATE",location.state);
  // const user = JSON.parse(localStorage.getItem('user'));
  const Navigate = useNavigate();
  const today = new Date();
  const maxDob = new Date(today.getFullYear() - 13, today.getMonth(), today.getDate())
    .toISOString()
    .split("T")[0];
  const minDob = new Date(today.getFullYear() - 30, today.getMonth(), today.getDate())
    .toISOString()
    .split("T")[0];
  // Age calculation is derived from DOB to keep the input simple and consistent.
  const ageDisplay = form.age
    ? today.getFullYear() -
    new Date(form.age).getFullYear() -
    (today < new Date(today.getFullYear(), new Date(form.age).getMonth(), new Date(form.age).getDate()) ? 1 : 0)
    : "--";
  const draftKey = `gamejam_register_draft_${storedUser?.user_id || user?.user_id}`;

  useEffect(() => {
    const savedDraft = localStorage.getItem(draftKey);
    if (!savedDraft) return;
    try {
      const parsed = JSON.parse(savedDraft);
      hasDraftRef.current = true;
      setForm((prev) => ({ ...prev, ...parsed }));
      showInfo("Draft loaded.");
    } catch (error) {
      localStorage.removeItem(draftKey);
    }
  }, []);

  useEffect(() => {
    let mounted = true;
    if (isregister === true) {
      setFormKey(true);
    }
    // if(!isregister) return false;
    const GameConfigData = async () => {
      if (mounted) {
        const User = JSON.parse(localStorage.getItem('user'));
        let data = await makeAPI('/api/gamejam_user_config', 'post', true, { event_id: event_id, user_id: user?.user_id || User?.user_id });

        if (data.status === "S" && data?.isRegistered == true) {
          setisregister(true);
          setFormKey(true);
          setSandbox(data.data?.game_details.build_url || "");
          if (hasDraftRef.current) {
            setForm((prev) => ({ ...prev, sub_id: data.data?.sub_id || "" }));
          } else {
            setForm((prev) => ({
              ...prev,
              name: data.data?.name || "",
              college: data.data?.college || "",
              email: data.data?.email || "",
              contact: data.data?.contact || "",
              gameDescription: data.data?.game_details?.description || "",
              gameTitle: data.data?.game_details?.title || "",
              // gameThumbnail: data.data?.game_details?.thumbnail || "",
              // gameFile: data.data?.sub_id || "",
              age: data.data?.dob || "",
              controlDescription: data.data?.game_details?.controls || "",
              sub_id: data.data?.sub_id || ""
            }));
          }

        }
      }
    }
    GameConfigData();
    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {

    const User_data = async () => {
      try {
        let user = await makeAPI('/api/get_user_data', 'post', true, {});
        if (user.status === "S") {
          setUser(user.data);
          if (!hasDraftRef.current) {
            setForm((prev) => ({ ...prev, email: user?.data.email }));
          }
        }
        else {
          OpenModal()
        }
      } catch (error) {
        console.log("error", error)
      }
    }
    User_data();

  }, [])

  const getImageDimensions = (file) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      const objectUrl = URL.createObjectURL(file);
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
        URL.revokeObjectURL(objectUrl);
      };
      img.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error("Image load failed"));
      };
      img.src = objectUrl;
    });

  const validate = async () => {
    const next = {};
    if (!form.name.trim()) next.name = "Name is required.";
    if (form.name.trim().length < 3) next.name = "Name char upto 3 is required.";
    if (!form.college.trim()) next.college = "College Name is required.";
    if (!form.email.trim()) {
      next.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      next.email = "Enter a valid email address.";
    }
    if (form.email !== user.email) {
      next.email = "Please use your registered email";
    }
    if (!form.contact.trim()) {
      next.contact = "Contact number is required.";
    } else if (!/^[0-9]{8,15}$/.test(form.contact)) {
      next.contact = "Enter a valid contact number.";
    }
    if (!form.age) {
      next.age = "Date of birth is required.";
    } else {
      const dob = new Date(form.age);
      const ageYears = today.getFullYear() - dob.getFullYear() -
        (today < new Date(today.getFullYear(), dob.getMonth(), dob.getDate()) ? 1 : 0);
      if (Number.isNaN(ageYears) || ageYears < 13 || ageYears > 30) {
        next.age = "Age must be between 13 and 30.";
      }
    }
    if (!form.gameTitle.trim()) next.gameTitle = "Game title is required.";
    if (form.gameTitle.trim().length < 5) next.gameTitle = "Game title char upto 5 is required.";

    if (!isregister) {

      if (!form.gameThumbnail) {
        next.gameThumbnail = "Game Thumbnail is required";
      } else {
        // console.log("TYPE",form.gameThumbnail.type)
        // console.log("size",form.gameThumbnail.size)
        // validate image Type .
        const allowedTypes = ["image/webp", "image/png", "image/jpg", "image/jpeg", "image/avif"];
        if (!allowedTypes.includes(form.gameThumbnail.type)) {
          next.gameThumbnail = "Not a Valid Type of Image";
        }

        // validate image size .
        if (form.gameThumbnail.size > maxSize) {
          next.gameThumbnail = "File Size Exceeds 1MB"
        }

        // Validate dimensions
        try {
          const { width, height } = await getImageDimensions(form.gameThumbnail);
          if (width !== 330 || height !== 185) {
            next.gameThumbnail = "Image must be 330 x 185 px";
          }
        } catch (err) {
          next.gameThumbnail = "Unable to read image dimensions.";
        }

      }
    } else {

      if (form?.gameThumbnail) {

        const allowedTypes = ["image/webp", "image/png", "image/jpg", "image/jpeg", "image/avif"];
        if (!allowedTypes.includes(form.gameThumbnail.type)) {
          next.gameThumbnail = "Not a Valid Type of Image";
        }

        // validate image size .
        if (form.gameThumbnail.size > maxSize) {
          next.gameThumbnail = "File Size Exceeds 1MB"
        }
        // Validate dimensions
        try {
          const { width, height } = await getImageDimensions(form.gameThumbnail);
          if (width !== 330 || height !== 185) {
            next.gameThumbnail = "Image must be 330 x 185 px";
          }
        } catch (err) {
          next.gameThumbnail = "Unable to read image dimensions.";
        }
      } else {
        console.log("No Files")
      }
    }

    if (!isregister) {

      if (!form.college_id) {
        next.college_id = "College ID card is required";
      } else {

        // validate image Type .
        const allowedTypes = ["image/webp", "image/png", "image/jpg", "image/jpeg", "image/avif"];
        if (!allowedTypes.includes(form.college_id.type)) {
          next.college_id = "Not a Valid Type of Image";
        }

        // validate image size .
        if (form.college_id.size > maxSize) {
          next.college_id = "File Size Exceeds 1MB"
        }

        // Validate dimensions
        // try {
        //   const { width, height } = await getImageDimensions(form.college_id);
        //   if (width !== 330 || height !== 185) {
        //     next.college_id = "Image must be 330 x 185 px";
        //   }
        // } catch (err) {
        //   next.college_id = "Unable to read image dimensions.";
        // }

      }
    } else {
      if (form?.college_id) {

        if (!form.college_id) {
          next.college_id = "Game Thumbnail is required";
        }
        const allowedTypes = ["image/webp", "image/png", "image/jpg", "image/jpeg", "image/avif"];
        if (!allowedTypes.includes(form?.college_id?.type)) {
          next.college_id = "Not a Valid Type of Image";
        }

        // validate image size .
        if (form.college_id?.size > maxSize) {
          next.college_id = "File Size Exceeds 1MB"
        }
      } else {
        console.log("NO filees");
      }
    }
    if (!form.gameDescription.trim()) next.gameDescription = "Game description is required.";
    if (!form.controlDescription.trim()) next.controlDescription = "Control description is required.";

    if (!isregister) {
      if (!form.gameFile) {
        next.gameFile = "Upload your WebGL build (ZIP).";
      } else if (!form.gameFile.name.toLowerCase().endsWith(".zip")) {
        next.gameFile = "Only .zip files are allowed.";
      } else if (form.gameFile.size > maxZipSize) {
        next.gameFile = "File size must be 100MB or less.";
      }
    }
    else {
      if (form.gameFile) {
        if (!form.gameFile.name.toLowerCase().endsWith(".zip")) {
          next.gameFile = "Only .zip files are allowed.";
        } else if (form.gameFile.size > maxZipSize) {
          next.gameFile = "File size must be 100MB or less.";
        }
      }
      else {
        console.log("No Files");
      }
    }
    if (!form.media) {
      next.media = "Required game orientation !"
    }
    return next;
  };

  const getDraftData = () => ({
    name: form.name,
    college: form.college,
    email: form.email,
    contact: form.contact,
    age: form.age,
    gameTitle: form.gameTitle,
    gameDescription: form.gameDescription,
    controlDescription: form.controlDescription,
    media: form.media,
    sub_id: form.sub_id
  });

  const isDraftEmpty = (data) => {
    const fields = [
      data.name,
      data.college,
      data.email,
      data.contact,
      data.age,
      data.gameTitle,
      data.gameDescription,
      data.controlDescription
    ];
    return fields.every((value) => !String(value || "").trim());
  };

  const handleSaveDraft = () => {
    const data = getDraftData();
    if (isDraftEmpty(data)) {
      showInfo("Nothing to save yet. Fill in the form before saving a draft.");
      return;
    }
    localStorage.setItem(draftKey, JSON.stringify(data));
    showSuccess("Draft saved on this device.");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!user) return OpenModal();
    setSuccess("");
    const next = await validate();
    setErrors(next);
    if (Object.keys(next).length > 0) return;
    window.dispatchEvent(new CustomEvent("app:navigation-start"));
    try {
      // set Form Data to Backend .
      const formData = new FormData();
      formData.append("game_thumbnail", form.gameThumbnail);
      formData.append("college_id", form.college_id);
      formData.append("game_zip", form.gameFile);
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("college", form.college);
      formData.append("contact", form.contact);
      formData.append("age", form.age);
      formData.append("game_title", form.gameTitle);
      formData.append("game_desc", form.gameDescription);
      formData.append("controller_desc", form.controlDescription);
      formData.append("media", form.media);
      formData.append("user_id", user?.user_id || storedUser?.user_id);
      if (FormKey === true) {
        // send submission id;
        formData.append("sub_id", form.sub_id);
      }
      let form_data = await makeApiCall_v1("/api/gamejam_submission", "POST", true, formData);
      // console.log("FORM_Data",form_data);
      if (form_data.status === "S" && form_data?.build_url !== null) {
        localStorage.removeItem(draftKey);
        setSandbox(form_data.build_url);
        setFormKey(true);
        if (form?.sub_id) {
          localStorage.setItem(`game_publish_stat_${form.sub_id}`, "unpublished");
        }
        setForm((prev) => ({ ...prev, gameThumbnail: null, gameFile: null, college_id: null }));
        // redirect to sandbox page with build url.
        setTimeout(() => {
          window.location.href = `/gamejam/sandbox?build_url=${encodeURIComponent(form_data.build_url)}&user_id=${encodeURIComponent(user?.user_id)}`;
          // Navigate(`/gamejam/sandbox?build_url=${encodeURIComponent(form_data.build_url)}&user_id=${encodeURIComponent(user?.user_id)}`);
        });
        setSuccess("View Sandbox & Publish your Build");
      }
      else if (form_data.status === "S") {
        localStorage.removeItem(draftKey);
        // setForm((prev) => ({ ...prev, gameThumbnail: null, gameFile: null , college_id: null}));
        // window.location.replace();
        // setSuccess("View Sandbox & Publish your Build");
        showSuccess("View Sandbox & Publish your Build");
        setFormKey(true);
      }else{
      showInfo(form_data.message);

      }
    } finally {
      window.dispatchEvent(new CustomEvent("app:navigation-end"));
    }
  };

  // if (event_id === undefined || event_id === "" || event_id === null) {
  //   return window.location.href = '/';
  // } 
  const currentUserId = user?.user_id || storedUser?.user_id;
  const sandboxUrl = sandbox
    ? `/gamejam/sandbox?build_url=${encodeURIComponent(sandbox)}&user_id=${encodeURIComponent(currentUserId || "")}`
    : "";


  return (
    <div className="gj-register-page">
      <style>{`
        textarea:focus, input:focus {
        border-color:#fff !important;
        }

        .gj-register-page {
          min-height: 100vh;
          background: var(--color-back);
          color: var(--heading-color);
          font-family: var(--body-font);
          padding: 100px 20px 60px;
        }
        .gj-register-page {
          --gj-or: var(--or, var(--main-color-one));
          --gj-or2: var(--or2, var(--main-color-two));
          --gj-dark2: var(--dark2, rgba(22, 22, 22, 0.92));
          --gj-bd: rgba(249,115,22,.2);
          --gj-bd2: rgba(249,115,22,.45);
          --gj-tx: var(--heading-color);
          --gj-tx2: rgba(255, 255, 255, 0.7);
        }
        .gj-register-container {
          max-width: 1100px;
          margin: 0 auto;
        }
        .gj-register-card {
          border: 1px solid var(--gj-bd);
          background: var(--gj-dark2);
          border-radius: 16px;
          padding: 24px;
        }
        .gj-register-card .uk-input,
        .gj-register-card .uk-textarea,
        .gj-register-card .uk-select {
          width: 100%;
        }
        .gj-date-input {
          background: transparent;
          color: var(--heading-color);
          border: 1px solid #3d3d3d;
          border-radius: 10px;
          padding: 10px 12px;
          width: 100%;
        }
        .gj-date-input::-webkit-calendar-picker-indicator {
          filter: invert(64%) sepia(84%) saturate(1766%) hue-rotate(350deg) brightness(100%) contrast(101%);
          cursor: pointer;
        }
        .gj-file-input {
          width: 100%;
          background: transparent;
          color: var(--heading-color);
          border: 1px solid #3d3d3d;
          border-radius: 10px;
          padding: 10px 12px;
        }
        .gj-file-input::file-selector-button {
          background: var(--main-color-one);
          // color: var(--color-back);
          // color:var(--heading-color);
          color: #FFF;
          border: none;
          padding: 8px 12px;
          border-radius: 8px;
          font-weight: 700;
          cursor: pointer;
          margin-right: 10px;
        }
        .gj-file-input::-webkit-file-upload-button {
          background: var(--main-color-one);
          // color: var(--color-back);
          border: none;
          padding: 8px 12px;
          border-radius: 8px;
          font-weight: 700;
          cursor: pointer;
          margin-right: 10px;
        }
        .gj-error {
          color: red;
          font-size: 12px;
          margin-top: 6px;
        }
        .gj-success {
          color: var(--main-color-two);
          font-weight: 600;
          margin-top: 8px;
        }
        .gj-register-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
          flex-wrap: wrap;
          margin-top: 16px;
        }
        .gj-split-card {
          border: 1px solid var(--gj-bd);
          background: var(--gj-dark2);
          border-radius: 16px;
          padding: 24px;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        // .gj-form-panel {
        //   max-height: calc(100vh - 160px);
        //   overflow-y: auto;
        //   padding-right: 8px;
        // }
        // .gj-form-panel::-webkit-scrollbar {
        //   width: 6px;
        // }
        // .gj-form-panel::-webkit-scrollbar-thumb {
        //   background: rgba(249,115,22,.35);
        //   border-radius: 999px;
        // }
        // .gj-form-panel::-webkit-scrollbar-track {
        //   background: rgba(255,255,255,.04);
        // }
        .gj-instructions {
          position: sticky;
          top: 110px;
          align-self: start;
        }
        .gj-toggle {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          padding: 3px;
          border-radius: 999px;
          background: rgba(255,255,255,.04);
          border: 1px solid rgba(255,255,255,.12);
        }
        .gj-toggle-btn {
          background: transparent;
          border: none;
          // color: var(--gj-tx2);
          color:#FFF;
          padding: 6px 12px;
          border-radius: 999px;
          font-weight: 800;
          font-size: 11px;
          letter-spacing: 2px;
          text-transform: uppercase;
          cursor: pointer;
          transition: all 0.2s ease;
          min-width: 92px;
          text-align: center;
          font-family: 'Barlow Condensed', sans-serif;
        }
        .gj-toggle-btn.active {
          background: var(--gj-or);
          // color: #080808;
          box-shadow: 0 6px 22px rgba(249,115,22,.35);
        }
        .gj-age-row {
          display: flex;
          gap: 10px;
          align-items: center;
        }
        .gj-age-badge {
          min-width: 90px;
          text-align: center;
          padding: 10px 12px;
          border-radius: 10px;
          background: rgba(249,115,22,.12);
          color: var(--gj-or);
          border: 1px solid var(--gj-bd2);
          font-weight: 700;
        }
        .gj-rules-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 12px;
        }
        .gj-rules-col-head {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 800;
          font-size: 11px;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 10px;
        }
        .gj-rules-col-head.ok { color: #22c55e; }
        .gj-rules-col-head.bad { color: #ef4444; }
        .gj-rule-item {
          display: grid;
          grid-template-columns: 22px 1fr;
          gap: 10px;
          align-items: start;
          padding: 10px 12px;
          background: rgba(255,255,255,.03);
          border: 1px solid rgba(255,255,255,.08);
          border-radius: 10px;
        }
        .gj-rule-ico {
          font-size: 14px;
          line-height: 1;
          margin-top: 2px;
        }
        .gj-rule-text {
          color: var(--gj-tx2);
          font-size: 12.5px;
          line-height: 1.45;
        }
        .gj-rule-text strong {
          color: var(--gj-tx);
          font-weight: 700;
        }
        .gj-rules-title {
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 900;
          font-size: 22px;
          letter-spacing: .5px;
          text-transform: uppercase;
          color: var(--gj-tx);
          margin-bottom: 12px;
        }
        @media (max-width: 960px) {
          .gj-rules-grid {
            grid-template-columns: 1fr;
          }
        }
        .gj-label {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-family: 'Barlow Condensed', sans-serif;
          font-weight: 700;
          font-size: 12px;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: var(--gj-tx2);
          margin-bottom: 6px;
        }
        .gj-instruction-list {
          margin: 0;
          padding-left: 18px;
          color: var(--gj-tx2);
          line-height: 1.6;
          font-size: 13px;
        }
        .gj-instruction-list li + li {
          margin-top: 10px;
        }
        .gj-sec-eyebrow {
          display: flex; align-items: center; gap: 12px;
          font-family: 'Barlow Condensed', sans-serif; font-weight: 700;
          font-size: 11px; letter-spacing: 4px; text-transform: uppercase;
          color: var(--gj-or); margin-bottom: 12px;
        }
        .gj-sec-eyebrow::before { content: ''; width: 28px; height: 2px; background: var(--gj-or); }
        .gj-sec-title {
          font-family: 'Barlow Condensed', sans-serif; font-weight: 900;
          font-size: clamp(28px, 4vw, 48px); letter-spacing: .5px;
          text-transform: uppercase; line-height: 1.0; color: var(--gj-tx);
        }
        .gj-sec-title .hl { color: var(--gj-or); }
        .gj-sec-divider {
          width: 64px; height: 3px; margin: 16px 0 28px;
          background: linear-gradient(90deg, var(--gj-or), rgba(249,115,22,.2));
        }
        .gj-action-btn {
          flex: 1;
          font-family: 'Barlow Condensed', sans-serif; font-weight: 800;
          font-size: 12px; letter-spacing: 2px; text-transform: uppercase;
          background: var(--gj-or); color: #fff;
          border: none; padding: 10px 0; cursor: pointer;
          transition: all .2s; display: flex; align-items: center; justify-content: center; gap: 6px;
          clip-path: polygon(5px 0%,100% 0%,calc(100% - 5px) 100%,0% 100%);
          text-decoration: none;
          min-width: 180px;
        }
        .gj-action-btn:hover { box-shadow: 0 0 16px rgba(249,115,22,.5); color: #fff; }
       
      `}</style>
      <p className='container' style={{ backgroundColor: "transparent", cursor: "pointer" }} onClick={() => {
        window.history.back();
      }}><i className="fa-solid fa-arrow-left"></i> {"BACK"}</p>
      <div className="gj-register-container">
        {/* <div className="gj-sec-eyebrow">Registration</div> */}
        <div className="gj-sec-title">CGES GameJam <span className="hl">Submission</span></div>
        <div className="gj-sec-divider"></div>
        <div className="uk-grid uk-grid-medium uk-grid-match" data-uk-grid="">
          <div className="uk-width-1-2@m">
            <div className="gj-split-card form-login">
              <div className="form-login__box gj-form-panel">
                <form onSubmit={handleSubmit}>
                  <div className="uk-grid uk-grid-small" data-uk-grid="">
                    <div className="uk-width-1-1">
                      <label className="gj-label">Student Name*</label>
                      <input
                        className="uk-input"
                        type="text"
                        placeholder="Full name"
                        value={form.name}
                        maxLength={80}
                        onChange={(e) => setForm((prev) => ({ ...prev, name: e.target.value }))}
                      />
                      {errors.name ? <div className="gj-error">{errors.name}</div> : null}
                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Institution Name</label>
                      <input
                        className="uk-input"
                        type="text"
                        placeholder="Institution Name"
                        value={form.college}
                        maxLength={80}
                        onChange={(e) => setForm((prev) => ({ ...prev, college: e.target.value }))}
                      />
                      {errors.college ? <div className="gj-error">{errors.college}</div> : null}

                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Institution ID card* <small className="uk-text-muted">(Under 100KB)</small></label> &nbsp;<br />
                      <small className="uk-text-muted">Note: Supported formats – PNG, JPG, JPEG, AVIF, WEBP</small>
                      {/* <label className="gj-label">Upload</label> */}
                      <input
                        className="gj-file-input mt-3"
                        style={{ fontSize: "15px" }}
                        type="file"
                        accept=".png,.jpg,.jpeg,.avif,.webp"
                        onChange={(e) =>
                          setForm((prev) => ({ ...prev, college_id: e.target.files?.[0] || null }))
                        }
                      />
                      {errors.college_id ? <div className="gj-error">{errors.college_id}</div> : null}

                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Email*</label>
                      <input
                        className="uk-input"
                        type="email"
                        placeholder="name@example.com"
                        value={form.email}
                        maxLength={120}
                        onChange={(e) => setForm((prev) => ({ ...prev, email: e.target.value }))}
                        disabled
                      />
                      {errors.email ? <div className="gj-error">{errors.email}</div> : null}
                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Contact*</label>
                      <div style={{ display: "flex" }}>
                        <span
                          className="uk-input"
                          style={{
                            width: "60px",
                            borderRight: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                        >
                          +91
                        </span>

                        <input
                          className="uk-input"
                          type="tel"
                          placeholder="Enter 10-digit number"
                          maxLength={10}
                          inputMode="numeric"
                          value={form.contact}
                          onChange={(e) => {
                            let value = e.target.value.replace(/\D/g, "").slice(0, 10);
                            setForm((prev) => ({ ...prev, contact: value }));
                          }}
                        />

                      </div>
                      {errors.contact ? <div className="gj-error">{errors.contact}</div> : null}
                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Age (13 +)*</label> &nbsp;
                      {/* DOB input + derived age badge for a cleaner UI */}
                      <div className="gj-age-row">
                        <input
                          className="gj-date-input"
                          type="date"
                          onKeyDown={(e) => e.preventDefault()}
                          placeholder="YYYY-MM-DD"
                          min={minDob}
                          max={maxDob}
                          maxLength={10}
                          value={form.age}
                          onFocus={(e) => e.target.showPicker && e.target.showPicker()}
                          onChange={(e) => setForm((prev) => ({ ...prev, age: e.target.value }))}
                        />
                        {/* <div className="gj-age-badge">{ageDisplay}</div> */}
                      </div>
                      {errors.age ? <div className="gj-error">{errors.age}</div> : null}
                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Game Title*</label>
                      <input
                        className="uk-input"
                        type="text"
                        placeholder="Your game title"
                        maxLength={100}
                        value={form.gameTitle}
                        onChange={(e) => setForm((prev) => ({ ...prev, gameTitle: e.target.value }))}
                      />
                      {errors.gameTitle ? <div className="gj-error">{errors.gameTitle}</div> : null}
                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Game Orientation*</label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      {/* Toggle UI for orientation (default landscape) */}
                      <div className="gj-toggle" role="group" aria-label="Game orientation">
                        <button
                          type="button"
                          className={`gj-toggle-btn ${form.media === "landscape" ? "active" : ""}`}
                          onClick={() => setForm((prev) => ({ ...prev, media: "landscape" }))}
                          aria-pressed={form.media === "landscape"}
                        >
                          Landscape
                        </button>
                        <button
                          type="button"
                          className={`gj-toggle-btn ${form.media === "portrait" ? "active" : ""}`}
                          onClick={() => setForm((prev) => ({ ...prev, media: "portrait" }))}
                          aria-pressed={form.media === "portrait"}
                        >
                          Portrait
                        </button>
                        <button
                          type="button"
                          className={`gj-toggle-btn ${form.media === "both" ? "active" : ""}`}
                          onClick={() => setForm((prev) => ({ ...prev, media: "both" }))}
                          aria-pressed={form.media === "both"}
                        >
                          Both
                        </button>
                      </div>
                      {errors.media ? <div className="gj-error">{errors.media}</div> : null}
                    </div>

                    <div className="uk-width-1-1">
                      <label className="gj-label">Game Thumbnail* <small className="uk-text-muted">(only 330 x 185 px, under 100 KB )</small></label> &nbsp;<br />
                      <small className="uk-text-muted">Note: Supported formats – PNG, JPG, JPEG, AVIF, WEBP</small>
                      {/* <label className="gj-label">Upload</label> */}
                      <input
                        className="gj-file-input mt-3"
                        style={{ fontSize: "15px" }}
                        type="file"
                        accept=".png,.jpg,.jpeg,.avif,.webp"
                        onChange={(e) =>
                          setForm((prev) => ({ ...prev, gameThumbnail: e.target.files?.[0] || null }))
                        }
                      />
                      {errors.gameThumbnail ? <div className="gj-error">{errors.gameThumbnail}</div> : null}

                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Choose a WebGL Build*<small className="uk-text-muted">(under 100 MB)</small></label> &nbsp; <br />
                      <small className="uk-text-muted">Note: Supported formats – .zip only</small>
                      <input
                        className="gj-file-input mt-3"
                        style={{ fontSize: "15px" }}
                        type="file"
                        accept=".zip,application/zip"
                        onChange={(e) => setForm((prev) => ({ ...prev, gameFile: e.target.files?.[0] || null }))}
                      />
                      {errors.gameFile ? <div className="gj-error">{errors.gameFile}</div> : null}
                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">Game Description*</label>
                      <textarea
                        className="uk-textarea bg-transparent text-white"
                        rows="3"
                        maxLength={250}
                        placeholder="Short summary of your game (max 250 chars)"
                        value={form.gameDescription}
                        style={{ border: "1px solid #3d3d3d" }}
                        onChange={(e) => setForm((prev) => ({ ...prev, gameDescription: e.target.value }))}
                      ></textarea>
                      {errors.gameDescription ? <div className="gj-error">{errors.gameDescription}</div> : null}
                    </div>
                    <div className="uk-width-1-1">
                      <label className="gj-label">How to PLay*</label>
                      <textarea
                        className="uk-textarea bg-transparent text-white"
                        rows="3"
                        maxLength={250}
                        placeholder="Explain controls (e.g., WASD to move, Space to jump)"
                        value={form.controlDescription}
                        style={{ border: "1px solid #3d3d3d" }}
                        onChange={(e) => setForm((prev) => ({ ...prev, controlDescription: e.target.value }))}
                      ></textarea>
                      {errors.controlDescription ? <div className="gj-error">{errors.controlDescription}</div> : null}
                    </div>

                  </div>

                  {success ? <div className="gj-success">{success}</div> : null}

                  <div className="gj-register-actions">
                    <button className="gj-action-btn" type="button" onClick={handleSaveDraft}>Save as draft</button>
                    <button className="gj-action-btn" type="submit">{isregister ? "save" : "Submit"}</button>
                    {isregister ? (
                      sandboxUrl ? (
                        <Link
                          className="gj-action-btn "
                          style={{ color: "#FFF", fontWeight: "800", fontSize: "12px" }}
                          to={sandboxUrl}
                        >
                          View Sandbox
                        </Link>
                      ) : (
                        <button className="gj-action-btn" type="button" disabled>
                          View Sandbox
                        </button>
                      )
                    ) : (
                      // <Link className="gj-action-btn " style={{ color: "var(--heading-color)", fontWeight: "800", fontSize: "12px" }} to="/gamejam">
                      //   Back to GameJam
                      // </Link> 
                      null
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="uk-width-1-2@m">
            <div className="gj-split-card gj-instructions mt-5">
              <div className="gj-sec-eyebrow">Instructions</div>
              <ul className="gj-instruction-list">
                <li>Use a 330 x 185 px thumbnail (PNG, JPG, JPEG, AVIF, or WEBP).</li>
                <li>Upload a WebGL build as a ZIP file only.</li>
                <li>Game title should be clear and at least 5 characters.</li>
                <li>Add a short game description and control details.</li>
                <li>Orientation defaults to landscape, change if needed.</li>
                <li>Age must be between 13 and 30.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const OpenModal = () => {
  if (window.UIkit && typeof window.UIkit.modal === "function") {
    window.UIkit.modal("#modal-login", { container: false }).show();
  }
};
